import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../../services/baseUrl";
const ActivatePage = () => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  // Extract the 'id' query parameter from the URL
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");

  useEffect(() => {
    if (id) {
      api
        .post("/api/activate", JSON.stringify(id), {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          if (response.data === "Activated") {
            setStatus("Activated");
            navigate("/login");
          } else {
            setStatus("Failed to activate");
          }
        })
        .catch((error) => {
          console.error("Error activating account:", error);
          setStatus("Error occurred");
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setStatus("Invalid or missing ID");
      setLoading(false);
    }
  }, [id, navigate]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h1>Account Activation</h1>
      {status && <p>{status}</p>}
    </div>
  );
};

export default ActivatePage;
